<template>
  <b-nav-item-dropdown text="Export">
    <div class="table-export">
      <div class="table-export__controls">
        <button
          class="table-export__control"
          :class="{'table-export__control--active': tab === 'default'}"
          @click="tab = 'default'"
        >
          Default Exports
        </button>
        <button
          class="table-export__control"
          :class="{'table-export__control--active': tab === 'custom'}"
          @click="tab = 'custom'"
        >
          Custom Exports
        </button>
      </div>
      <div v-if="tab === 'default'" class="table-export__content">
        <draggable class="table-export__group" :list="defaultColumns">
          <checkbox
            v-for="column in defaultColumns"
            :key="`${column.key}-default`"
            class="table-export__group-item"
            disabled
            :checked="true"
          >
            {{ column.label }}
          </checkbox>
        </draggable>

        <button type="button" :disabled="loading" @click="exportData(defaultColumns)">
          Export {{ defaultColumns.length }} columns
        </button>
      </div>
      <div v-if="tab === 'custom'" class="table-export__content">

        <draggable class="table-export__group" :list="allColumns">
          <checkbox
            v-for="column in allColumns"
            :key="`${column.key}-custom`"
            class="table-export__group-item"
            :checked.sync="column.selectExport"
            @click="$set(column, 'selectExport', !column.selectExport)"
          >
            {{ column.label }}
          </checkbox>
        </draggable>
        <button type="button" :disabled="loading" @click="exportData(allSelected)">
          Export {{ allSelected.length }} columns
        </button>
      </div>
    </div>
  </b-nav-item-dropdown>
</template>

<script>
import {BNavItemDropdown} from 'bootstrap-vue';

import Draggable from "vuedraggable";
import Checkbox from '../TableCheckbox'

export default {
  components: {
    BNavItemDropdown,
    Draggable,
    Checkbox
  },
  props: {
    defaultColumns: {
      type: Array,
    },
    allColumns: {
      type: Array,
    }
  },
  data() {
    return {
      tab: 'default',
      loading: false,
    }
  },
  computed: {
    defaultKeys() {
      return this.defaultColumns.map(c => c.key)
    },
    allSelected() {
      return this.allColumns ? this.allColumns.filter(c => c.selectExport) : []
    }
  },
  methods: {
    exportData(columns) {
      this.loading = true;

      this.$emit('export', columns.map(i => i.key), () => {
        this.loading = false;
      })
    },
  },
}
</script>